/*
 * Author: Dw
 * File Created: Tuesday, 24-11-19 04:21 pm
 * Last Modified: Tuesday, 24-11-19 04:25 pm, by Dw
 */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
function Notice(props: SvgIconProps) {
  return <SvgIcon inheritViewBox {...props} data-sentry-element="SvgIcon" data-sentry-component="Notice" data-sentry-source-file="index.tsx">
      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" data-sentry-element="svg" data-sentry-source-file="index.tsx">
        <circle cx="22" cy="22.001" r="22" fill="currentColor" data-sentry-element="circle" data-sentry-source-file="index.tsx" />
        <rect x="19.8008" y="9.46094" width="4.4" height="17.6" rx="2.2" fill="#1B1E27" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
        <rect x="19.5801" y="29.701" width="4.84" height="4.84" rx="2.42" fill="#1B1E27" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
      </svg>
    </SvgIcon>;
}
export default Notice;